import { combineReducers, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import sagas from "../sagas/sagas";
import user from "./user.store";
import users from "./users.store";
import userDetail from "./userDetail.store";

import stations from "./stations.store";
import stationDetail from "./stationDetail.store";

import keplerGlReducer from "kepler.gl/reducers";
import { taskMiddleware } from "react-palm/tasks";

import snackbarReducer from "./slices/snackbar";
import menuReducer from "./slices/menu";

import { uiStateUpdaters } from "kepler.gl/reducers";
import { LOCALE_CODES } from "kepler.gl/localization";

import { persistStore } from "redux-persist";
import { ActionTypes } from "kepler.gl/actions";
//import { LOCALES } from 'keplerConfigs/localization/locales'


const initialState = {};


const customizedKeplerGlReducer = keplerGlReducer
  .initialState({
    uiState: {
      locale: LOCALE_CODES.en,
      readOnly: true,
      centerMap: true,
      //activeSidePanel: "filter",
      currentModal: null,
      mapControls: {
        ...uiStateUpdaters.DEFAULT_MAP_CONTROLS,
        visibleLayers: {
          show: false,
        },
        mapLegend: {
          show: false,
          active: false,
        },
        toggle3d: {
          show: false,
        },
        splitMap: {
          show: false,
        },
        mapDraw: {
          show: false,
        },
        mapLocale: {
          show: false,
        },
      },

    },
    mapState: {
      latitude: 39.23081874424652,
      longitude: 9.112565449928983,
    },
  })
  .plugin({
    ADD_FILTER: (state, action) => ({
      ...state,
      ...(state.visState.filters = [
        {
          dataId: ["tdm_temp"],
          id: "kyq8rehga",
          name: ["time"],
          type: "timeRange",
          value: [1670763600000, 1670849400000],
          enlarged: true,
          plotType: "histogram",
          animationWindow: "free",
          yAxis: null,
          speed: 1,
        },
      ]),
    }),
    HIDE_FILTER: (state, action) => ({
      ...state,
      ...(state.visState.filters = []),
    }),
    [ActionTypes.TOGGLE_SIDE_PANEL]: (state, { payload: id }) => {
      // This funciton get called AFTER the default TOGGLE_SIDE_PANEL in kepler.gl reducer is applied
      if (id === "layer") {
        return {
          ...state,
          uiState: {
            ...state.uiState,
            // set panel to anything you want here
            activeSidePanel: "filter",
          },
        };
      }
      // do nothing for other panel changes
      return state;
    },
  });

// const mapReducer = handleActions(
//   {
//     [ActionTypes.LAYER_CLICK]: (state, action) => ({
//       ...state,
//       viewport: action.payload,
//     }),
//     // ADD_FILTER: (state) => ({
//     //   ...state,
//     //   viewport: 'test',
//     // }),
//   },
//   {}
// );

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
  user: user,
  users: users,
  userDetail: userDetail,
  stations: stations,
  stationDetail: stationDetail,
  keplerGl: customizedKeplerGlReducer,

  ///////////
  snackbar: snackbarReducer,
  menu: menuReducer,
});

const store = createStore(
  reducer,
  initialState,
  applyMiddleware(taskMiddleware, sagaMiddleware)
);
sagaMiddleware.run(sagas);

const persister = persistStore(store);

export { store, persister };
